import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {ErrorList} from '../controls/error-prompt/error-list.model';

@Component({
	selector: 'app-enter-csv-dialog',
	templateUrl: './enter-csv-dialog.component.html',
	styleUrls: ['./enter-csv-dialog.component.css']
})
export class EnterCsvDialogComponent implements OnInit {

	// Injected Properties
	header = 'Enter Comma Separate Value';
	helpString = 'Enter values separated by commas (Ex. ABC, DEF, GHI)';
	validator: (csv: string) => ErrorList[];
    pattern: RegExp;
	keyRestriction: RegExp;

	// Properties
	csv = '';
	errors: ErrorList[] = [];
	@ViewChild('csvField', { read: ElementRef, static: true }) csvField: ElementRef;

	// Class Functions
	constructor(
		private dialogBox: MatDialogRef<EnterCsvDialogComponent>,
		@Inject(MAT_DIALOG_DATA) private data: any
	) { }

	// Event Functions
	ngOnInit() {

		// Setting the injected properties
		if (this.data.header) {
			this.header = this.data.header;
		}
		if (this.data.helpString) {
			this.helpString = this.data.helpString;
		}
		if (this.data.validator) {
			this.validator = this.data.validator;
		}
		if (this.data.pattern) {
		    this.pattern = this.data.pattern;
        }
		if (this.data.keyRestriction) {
		    this.keyRestriction = this.data.keyRestriction;
        }
	}

	save() {
		// PRE: the save button is clicked
		// POST: closes the dialog with the CSV
		if (this.validator) {
			this.errors = this.validator(this.csv);

			// If an error comes back with an empty element ref, populate that as our CSV field
			// If it comes back as null, don't show it with any ElementRef
			this.errors.forEach(error => {
				if (error.fieldRef && !error.fieldRef.nativeElement) {
					error.fieldRef = this.csvField;
				}
			});
		}
		if (this.errors.length == 0) {
			this.dialogBox.close(this.csv);
		}
	}

	cancel() {
		// PRE: the cancel button is clicked
		// POST: closes the dialog with null
		this.dialogBox.close(null);
	}

	validateKey(event: KeyboardEvent) {
	    // PRE: a key is entered into the csv
        // POST: ensures that it maches the format
        if (this.keyRestriction &&
            !this.keyRestriction.test(event.key) &&
            event.key != 'Backspace' &&
            event.key != 'Tab') {
            event.preventDefault();
            return false;
        }
    }

	// Methods
}
